import './header.scss';

// const button = document.querySelector('.header__change-theme');
// if (button) {
//     button.addEventListener('click', function () {
//         if (document.body.hasAttribute('data-theme')) {
//             document.body.removeAttribute('data-theme');
//         } else {
//             document.body.setAttribute('data-theme', 'dark');
//         }
//     })
// }


const categoryMenu = document.querySelector('.header__category-menu');

if (categoryMenu) {
    const params = new URLSearchParams(window.location.search);
    const currentCategory = params.get('category') || '';
    const button = categoryMenu.querySelector('.header__category-menu_current');
    const menuList = categoryMenu.querySelector('.header__category-menu_box');

    Array.from(categoryMenu.querySelectorAll('li')).forEach(item => {
        const key = item.getAttribute('data-key');
        if (key === currentCategory) {
            button.innerHTML = item.innerHTML;
        }
    });

    button.addEventListener('click', () => {
        menuList.classList.toggle('hidden');
    });
}
